






















































import Vue from 'vue';
import { mapState, mapGetters } from 'vuex';
import { AxiosError, AxiosResponse } from 'axios';

import OrderAPI from '@/services/OrderAPI';
import ItemAPI from '@/services/ItemAPI';

import Util from '@/util/Util';
import utilMixin from '@/mixin/Util';
import ValidateUtil from '@/util/ValidateUtil';

import Section from '@/components/Bulma/Section.vue';
import OrderItemList from '@/components/OrderItemList.vue';
import ShippingSelector from '@/components/ShippingSelector.vue';
import PaymentSelector from '@/components/PaymentSelector.vue';
import Contact from '@/components/Contact.vue';
import ContactSelector from '@/components/ContactSelector.vue';
import Coupon from '@/components/Coupon.vue';
import CouponSelector from '@/components/CouponSelector.vue';

import Field from '@/components/Bulma/Field.vue';
import TInput from '@/components/Bulma/TInput.vue';
import HorizontalField from '@/components/Bulma/HorizontalField.vue';

import Order from '@/types/Order';
import ContactInfo from '@/types/ContactInfo';
import Shipment from '@/types/Shipment';
import Payment from '@/types/Payment';

import PayPalButton from '@/components/PayPalButton.vue';

export default Vue.extend({
    name: 'ShoppingCart',

    components: {
        Section,
        OrderItemList,
        ShippingSelector,
        Contact,
        Coupon,
        Field,
        TInput,
        HorizontalField,
        ContactSelector,
        CouponSelector,
        PaymentSelector,
        PayPalButton
    },

    mixins: [utilMixin],

    created() {
		Util.updateHeaders((this as any).$text('shoppingCart'), (this as any).$text('yourShoppingCart'), process.env.VUE_APP_DEFAULT_IMAGE);
    },

    computed: {
        ...mapState(['language', 'order']),

		...mapGetters(['isSignedIn'])
    },

    data() {
        return {
            currentStage: 'ItemStage',
            error: {
                save: ''
                },
            status: '',
            isLoading: false,
            isSaved: {
                contactInfo: true,
                shipment: true,
                payment: true
            },
            orderEmail: '',
            isOrderCompleted: false
        };
    },

    methods: {
        completeOrder(order: Order): void {
            this.error.save = '';
            this.status = '';
            this.orderEmail = order.contactInfo.email;

            const handleResponse = (response: AxiosResponse) => {
                    this.$store.commit('setOrder', {});
                    window.scrollTo(0, 0);
                    this.isOrderCompleted = true;
                    this.loadItems();
                };

            const handleError = (error: AxiosError) => {
                    if (error.response) {
                        if (error.response.status === 409) {
                            // gives an updated order
                            this.$store.commit('setOrder', error.response.data.message);
                            this.error.save = this.$text('shopping-cart.error.1');
                            return;
                        }
                        this.error.save = error.response.data.message;
                    }
                };

            this.isLoading = true;
            OrderAPI
                .complete(order.orderId)
                .then(handleResponse)
                .catch(handleError)
                .finally(() => this.isLoading = false);
        },

        loadItems(): void {
            ItemAPI
                .getItems()
                .then((axiosResponse: AxiosResponse) => this.$store.commit('setItems', axiosResponse.data))
                .catch((error: AxiosError) => error);
        },

        checkContactInfoSet(contactInfo: ContactInfo): boolean {
            return ValidateUtil.validateContactInfo(contactInfo).length === 0;
        },

        checkShippingSet(shipment: Shipment): boolean {
            return !!shipment && !!shipment.shippingId;
        },

        checkPaymentSet(payment: Payment): boolean {
            return !!payment && !!payment.paymentId;
        }
    }
});
